module.exports = __webpack_public_path__ + "img/default-cover-square.4a7cbdd9.png";